import './Modal.less';

export { default as Popup } from './Popup';

export const prefix = 'bm-c-modal';
